<template>
  <pt-customer-of-system class="pt-customer-of-system__withData" @deleteCustomer="deleteCustomer" ref="table" :rolesList="rolesList"></pt-customer-of-system>
</template>

<script>
import PtCustomerOfSystem from './index'
export default {
  name: 'pt-customer-of-system__withData',
  components: {
    'pt-customer-of-system': PtCustomerOfSystem
  },
  data () {
    return {
      rolesList: []
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    deleteCustomer (userLogin) {
      let data = {
        userLogin: userLogin
      }
      this.$store.dispatch('deleteOrganizationUser', data).then(res => {
        console.log(1111111)
        this.$message.success('删除系统用户成功')
        this.$refs.table.getTableData(this.page)
      }).catch(err => {
        this.$message.error(err || '删除系统用户失败')
      })
    },
    getRolesList () {
      let data = {}
      this.$store.dispatch('rolesList', data).then(res => {
        this.rolesList = res.data
      }).catch(err => {
        this.$message.error(err || '获取角色列表失败')
      })
    }
  },
  created () {
    this.getRolesList()
  }
}
</script>
